import {AuthWebConfig} from "@auspost/auth0-uiim-types";

declare var apiBaseEndpoint: string;
declare var publicBaseUrl: string;
declare var securepayHost: string;
declare var securepayClientId: string;
declare var addressLookupBaseEndpoint: string;
declare var addressLookupApiKey: string;
declare var mockUtils: boolean;
declare var portalUrl: string;
declare var authScriptUrl: string;
declare var loginUrl: string;
declare var clientId: string;
declare var env: string;
declare var redirectUrl: string;
declare var audience: string;
declare var scope: string;

interface Config {
  publicConfig: {
    publicBaseUrl: string;
  },
  ordersConfig: {
    ordersEndpoint: string;
  }
  userSettings: {
    detailsEndpoint: string;
  }
  smsConfig: {
    sendPinEndpoint: string,
    checkPinEndpoint: string,
  },
  securepay: {
    scriptUrl: string,
    merchantCode: string
    clientId: string
  },
  addressLookupConfig: {
    endpoint: string,
    apiKey: string
  },
  mockConfig: {mockUtils: boolean},
  portalConfig: {
    portalLoginUrl: string;
    portalHelp: string;
    portalReportGuide: string;
  },
  auth:{
    loginUrl: string;
    authScriptUrl?: string;
    authWebConfig?: AuthWebConfig;
  },
  servicePrice: number
}

export let config: Config;

config = {
  publicConfig: {
    publicBaseUrl: `${publicBaseUrl}`
  },
  ordersConfig: {
    ordersEndpoint: `${apiBaseEndpoint}/orders`
  },
  smsConfig: {
    sendPinEndpoint: `${apiBaseEndpoint}/phone`,
    checkPinEndpoint: `${apiBaseEndpoint}/phone/verify`
  },
  userSettings: {
    detailsEndpoint: `${apiBaseEndpoint}/user/details`
  },
  securepay: {
    scriptUrl: `${securepayHost}/v3/ui/client/securepay-ui.min.js`,
    merchantCode: '5AW0055',
    clientId: `${securepayClientId}`,
  },
  addressLookupConfig: {
    endpoint: `${addressLookupBaseEndpoint}`,
    apiKey: `${addressLookupApiKey}`
  },
  mockConfig: {
    mockUtils: (`${mockUtils}` == 'true')
  },
  portalConfig: {
    portalLoginUrl: `${portalUrl}`,
    portalHelp: `${portalUrl}/static/media/docs/propertyTransferHelp.pdf`,
    portalReportGuide: `${portalUrl}/static/media/docs/propertyTransferReportGuide.pdf`
  },
  auth:{
    loginUrl : `${loginUrl}`,
    authScriptUrl: `${authScriptUrl}`,
    authWebConfig: {
      clientId: `${clientId}`,
      env: `${env}` as 'prod' | 'sandbox' | 'vtest' | 'stest' | 'ptest' | 'dev' | 'playpen' | 'localhost',
      redirectUrl: `${redirectUrl}`,
      auth0SessionRequired: true,
      audience: `${audience}`,
      scope: `${scope}`,
      caller: 'PVOI',
      product: 'PVOI',
      channel: 'WEB',
      cssoSessionConfig: {
        skipCheck: true,
        skipExchange: true,
        skipRefresh: true
      },
      verifyAuthenticationOnFocus: true
    }
  },
  servicePrice: 14.95
}

if (env === 'localhost') {
  config.auth.authWebConfig.stubDomain = 'localhost:3000';
}


